<template>
  <div class="sub-page">
    <div class="main">
      <div class="player-info">
        <img :src="playerDetail.image" alt="">
        <div class="info">
          <div class="name">{{playerDetail.name}}</div>
          <div class="name">出生年月：{{playerDetail.birthday?playerDetail.birthday.slice(0,10):''}}</div>
          <div class="name">代表队：{{playerDetail.unitName}}</div>
          <div class="name">参赛项目：{{programName}}</div>
        </div>
        <div class="medal">
          <div class="medal-item">
            <img src="../../../assets/image/1.png" alt="">
            <div>{{ playerDetail.goldMedal }}</div>
          </div>
          <div class="medal-item">
            <img src="../../../assets/image/2.png" alt="">
            <div>{{ playerDetail.silverMedal }}</div>
          </div>
          <div class="medal-item">
            <img src="../../../assets/image/3.png" alt="">
            <div>{{ playerDetail.bronzeMedal }}</div>
          </div>
          <div class="medal-item">
            <img src="../../../assets/image/4.png" alt="">
            <div>{{ playerDetail.goldMedal+playerDetail.silverMedal+playerDetail.bronzeMedal }}</div>
          </div>
        </div>
      </div>
      <div class="title">
        <span>报项信息</span>
        <img src="../../../assets/icon/delep_signup.png" alt="">
      </div>
      <div class="signup">
        <span v-for="(item,index) in playerDetail.projectList" :key="index">{{ item.combatName }}{{ index+1!=playerDetail.projectList.length?'、':'' }}</span>
      </div>
      <div class="title">
        <span>比赛成绩</span>
        <img src="../../../assets/icon/delep_score.png" alt="">
      </div>
      <div class="score-list">
        <!-- <div class="score-item" v-for="(item,index) in playerDetail.projectList" :key="index">
            <div class="program">
              <span>{{item.combatName}}</span>
              <img :src="`../../../assets/image/${item.ranking}.png`" alt="">
            </div>
            <div class="item-card" v-for="i,j in item.scoreList" :key="j">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
            <div class="item-card">
              <h3>&ensp;重庆道吧集团</h3>
              <div class="score">成绩：586_20x&ensp;&ensp;&ensp;2024-07-18</div>
              <h4>&ensp;李小龙</h4>
              <div class="pos-icon">破市记录</div>
            </div>
        </div> -->
      </div>
      <!-- <div class="title">
        <span>数据分析</span>
        <img src="../../../assets/icon/delep_data.png" alt="">
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'DelegationPlayer',
  props: {
  },
  data() {
    return {
      programName:this.$route.query.programName?decodeURIComponent(this.$route.query.programName):'暂无',
      agencyId:this.$route.query.agencyId?decodeURIComponent(this.$route.query.agencyId):-1,
      playerId:this.$route.query.playerId?decodeURIComponent(this.$route.query.playerId):-1,
      matchId:this.$route.query.playerId?decodeURIComponent(this.$route.query.matchId):-1,
      playerDetail:{},
    }
  },
  components: {},
  mounted() {
    this.getSeriesPlayerDetail()
  },
  methods: {
   async getSeriesPlayerDetail(){
     let data={
      agencyId:this.agencyId,
      playerId: this.playerId,
      matchId:this.matchId
     }
       
     try {
        let res =await this.$api.district.seriesPlayerDetail(data)
        if(res.status ==0){
          this.playerDetail=res.data
        }else{
          this.message.error(res.msg)
      }
     } catch (error) {
        console.log(error);
     }
   }
   
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page{
  width: 100%;
  background-color: #FBFBFB;
  padding-top: 30px;
  padding-bottom: 30px;

  .main{
    width: 1200px;
    margin: 0 auto;
    box-sizing: border-box;
    background-color: #FFFFFF;
    box-shadow: 0px 2px 6px 0px rgba(33,26,30,0.08);
    border-radius: 10px;  
    .player-info{
      width: 100%;
      padding: 30px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #F1F1F1;
      margin-bottom: 30px;
      color: #333333;
      img:first-child{
        width: 120px;
        height: 120px;
      }
      .info{
        width: 580px;
        div:first-child{
          font-size: 20px;
          font-weight: bold;
          margin-bottom: 15px;
        }
        div:nth-child(2),
        div:nth-child(3){
          font-size: 14px;
          margin-bottom: 6px;
        }
      }
      .medal{
        display: flex;
        width: 400px;
        justify-content: flex-start;
        align-items: center;
        text-align: center;
        .medal-item{
          width: 100px;
          margin-left: auto;
        }
        img{
          width: 50px;
          height: 50px;
        }
      }
    }
    .title{
      position: relative;
      padding-left: 75px;
      color: #333333;
      font-size: 18px;
      font-weight: bold;
      img{
        position: absolute;
        top: -4px;
        left: 30px;
        width: 36px;
        height: 36px;
      }
    }
    .signup{
      font-size: 14px;
      color: #333333;
      padding-top: 20px;
      padding-left: 50px;
      padding-bottom: 20px;
      margin-bottom: 30px;
      border-bottom: 1px solid #F1F1F1;
    }
    .score-list{
      width: 100%;
      padding: 0 30px;
      min-height: 100px;
      .score-item{
        margin-top: 10px;
        height: 220px;
        margin-bottom: 20px;
        padding-bottom: 30px;
        padding-left: 30px;
        border-bottom: 1px solid #F1F1F1;
        .program{
          margin: 10px 0;
          display: flex;
          justify-content: space-between;
        }
        .item-card{
          width: 30%;
          height: 150px;
          background: -webkit-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
          background: -o-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
          background: -moz-linear-gradient(#FFDFA8, #FFD297,#E1B171); 
          background: linear-gradient(#FFDFA8, #FFD297,#E1B171); 
          border-radius:10px;
          padding: 2% 2%;
          position: relative;
          float: left;
          margin-right: 3.3%;
          .score{
            height: 50px;
            background: white;
            width: 100%;
            border-radius:5px;
            line-height: 50px;
            padding-left: 10px;
            margin-bottom: 10px;
          }
          .pos-icon{
            width: 80px;
            text-align: center;
            line-height: 30px;
            height: 30px;
            background: #124584;
            color: white;
            border-radius: 0 10px 0px 10px;
            position: absolute;
            right: 0;
            top: 0;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/district/views/delegation/components/DelegationPlayer.vue